var _rect, _title, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPointer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {},
    xmlSpace: "preserve",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "backgroundrect",
    width: "100%",
    height: "100%",
    x: 0,
    y: 0,
    fill: "none",
    stroke: "none"
  })), /*#__PURE__*/React.createElement("g", {
    className: "currentLayer",
    style: {}
  }, _title || (_title = /*#__PURE__*/React.createElement("title", null, "Layer 1")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "svg_1",
    className: "selected",
    fillOpacity: 1,
    fill: "#448bc9"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svg_2",
    fill: "#448bc9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M506.794,212.481c-6.714-7.588-16.458-11.939-26.735-11.939H357.845c-0.081-0.002-0.162-0.004-0.244-0.004h-5.787    l-9.268-17.956c-6.257-12.124-18.792-19.655-32.712-19.655H199.727c-13.427,0-25.907,6.487-33.386,17.354    c-4.679,6.798-12.54,10.857-21.028,10.857h-8.506c-3.153-3.461-7.733-5.643-12.822-5.643H112.07v-5.665    c0-9.32-7.719-16.903-17.207-16.903H81.182C77.308,153.039,67.497,146,56.035,146c-11.462,0-21.272,7.039-25.146,16.927H17.207    C7.719,162.927,0,170.51,0,179.83v169.266C0,358.417,7.719,366,17.207,366h77.656c9.488,0,17.207-7.583,17.207-16.904v-5.665    h11.914c5.089,0,9.669-2.182,12.821-5.642h8.507c8.489,0,16.351,4.059,21.028,10.857C173.819,359.513,186.3,366,199.727,366    h98.984c20.193,0,36.621-16.02,36.621-35.711v-1.904h2.207c20.193,0,36.621-16.02,36.621-35.711v-1.904h2.207    c20.193,0,36.621-16.02,36.621-35.711v-1.904h65.956c11.012,0,21.546-5.116,28.182-13.686l0.544-0.703    c2.792-3.606,4.33-8.086,4.33-12.614C512,221.13,510.151,216.274,506.794,212.481z M56.035,161    c6.569,0,11.914,5.072,11.914,11.307s-5.345,11.308-11.914,11.308c-6.569,0-11.914-5.073-11.914-11.308S49.466,161,56.035,161z     M126.191,326.527c0,1.05-0.99,1.904-2.207,1.904H112.07V306.31c0-4.142-3.357-7.5-7.5-7.5s-7.5,3.358-7.5,7.5v42.786    c0,1.05-0.99,1.904-2.207,1.904H17.207C15.99,351,15,350.146,15,349.096V179.83c0-1.049,0.99-1.903,2.207-1.903h12.532    c2.641,11.815,13.429,20.688,26.296,20.688c12.867,0,23.655-8.873,26.296-20.688h12.532c1.217,0,2.207,0.854,2.207,1.903v99.209    c0,4.142,3.357,7.5,7.5,7.5s7.5-3.358,7.5-7.5v-78.544h11.914c1.217,0,2.207,0.854,2.207,1.904V326.527z M298.711,238.156    c-4.143,0-7.5,3.358-7.5,7.5c0,4.142,3.357,7.5,7.5,7.5h99.277v1.904c0,11.42-9.699,20.711-21.621,20.711h-9.479    c-0.076-0.002-0.152-0.003-0.229-0.003h-77.656c-4.143,0-7.5,3.358-7.5,7.5c0,4.142,3.357,7.5,7.5,7.5h70.156v1.907    c0,11.42-9.699,20.711-21.621,20.711h-9.707c-0.293,0-0.582,0.017-0.867,0.049c-0.154-0.009-0.311-0.014-0.468-0.014h-55.948    c-4.143,0-7.5,3.358-7.5,7.5c0,4.142,3.357,7.5,7.5,7.5h49.783v1.869c0,11.42-9.699,20.711-21.621,20.711h-98.984    c-8.489,0-16.351-4.059-21.028-10.857c-7.479-10.866-19.959-17.354-33.386-17.354h-4.121V206.138h4.121    c13.427,0,25.907-6.487,33.386-17.354c4.678-6.799,12.539-10.857,21.028-10.857h110.107c8.283,0,15.71,4.42,19.382,11.535    l5.717,11.076h-6.717c-12.659,0-25.373-1.218-37.787-3.621c-4.066-0.79-8.002,1.872-8.788,5.938    c-0.787,4.067,1.871,8.001,5.938,8.789c13.351,2.584,27.023,3.895,40.637,3.895h18.787c0.081,0.002,0.162,0.004,0.243,0.004    h109.228v22.613H298.711z M495.809,229.584l-0.544,0.703c-3.814,4.927-9.916,7.869-16.32,7.869h-7.471v-22.614h8.585    c5.983,0,11.633,2.507,15.502,6.879c0.928,1.049,1.439,2.375,1.439,3.732C497,227.391,496.588,228.578,495.809,229.584z",
    id: "svg_3",
    fill: "#448bc9"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "svg_4"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "svg_5"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "svg_6"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "svg_7"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "svg_8"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "svg_9"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "svg_10"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "svg_11"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "svg_12"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "svg_13"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "svg_14"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "svg_15"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "svg_16"
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "svg_17"
  })), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "svg_18"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPointer);
export default __webpack_public_path__ + "static/media/pointer.d8c7cda8fe710f036b38ce185ce94ce9.svg";
export { ForwardRef as ReactComponent };